module.exports = "https://www.niulinkcloud.com/_next/static/media/mobileBanner2.6ab2b1644489e8a04fcd6ccc674bb7bf.png";